import React, { useState, useEffect } from 'react';
import { DataGrid } from '@material-ui/data-grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import {
	Typography,
	Box,
	TextField,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
} from '@material-ui/core';
import SeriesDialog from './SeriesDialog';
import SeriesService from '../../../services/series.service';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';

export default function SeriesTab() {
	const [loading, setLoading] = useState(false);
	const [series, setSeries] = useState([]);
	const [filteredSeries, setFilteredSeries] = useState([]);
	const [openDialog, setOpenDialog] = useState(false);
	const [currentSeries, setCurrentSeries] = useState(null);
	const [searchTerm, setSearchTerm] = useState('');
	const [selectedTeam, setSelectedTeam] = useState('ALL');

	const loadSeries = async () => {
		setLoading(true);
		try {
			const seriesData = await SeriesService.get();
			if (seriesData) {
				setSeries(seriesData);
				setFilteredSeries(seriesData);
			}
		} catch (error) {
			console.error('Error al cargar series:', error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		loadSeries();
	}, []);

	useEffect(() => {
		let filtered = Array.isArray(series) ? [...series] : [];

		// Aplicar filtro de búsqueda
		if (searchTerm) {
			filtered = filtered.filter(
				(serie) =>
					serie.serie.toLowerCase().includes(searchTerm.toLowerCase()) ||
					serie.description.toLowerCase().includes(searchTerm.toLowerCase())
			);
		}

		// Aplicar filtro de equipo
		if (selectedTeam !== 'ALL') {
			filtered = filtered.filter((serie) => serie.team === selectedTeam);
		}

		setFilteredSeries(filtered);
	}, [searchTerm, selectedTeam, series]);

	const handleAddSeries = () => {
		setCurrentSeries(null);
		setOpenDialog(true);
	};

	const handleEditSeries = (serie) => {
		setCurrentSeries(serie);
		setOpenDialog(true);
	};

	const handleSaveSeries = async (serieData) => {
		try {
			if (serieData.id) {
				await SeriesService.update(serieData);
			} else {
				delete serieData.id;
				await SeriesService.create(serieData);
			}
			loadSeries();
			setOpenDialog(false);
		} catch (error) {
			console.error('Error al guardar serie:', error);
		}
	};

	const handleDeleteSeries = async (serie) => {
		try {
			await SeriesService.delete(serie.id);
			loadSeries();
		} catch (error) {
			console.error('Error al eliminar serie:', error);
		}
	};

	const columns = [
		{ field: 'team', headerName: 'Equipo', width: 150 },
		{ field: 'serie', headerName: 'Serie', width: 150 },
		{ field: 'description', headerName: 'Descripción', flex: 1 },
		{
			field: 'actions',
			headerName: '#',
			width: 50,
			renderCell: (params) => (
				<IconButton
					size='small'
					color='primary'
					onClick={() => handleEditSeries(params.row)}>
					<EditIcon />
				</IconButton>
			),
		},
	];

	return (
		<div>
			<Box
				display='flex'
				justifyContent='space-between'
				alignItems='center'
				mb={2}>
				<Typography variant='h6'>Gestión de Series</Typography>
				<Button
					variant='contained'
					color='primary'
					startIcon={<AddIcon />}
					onClick={handleAddSeries}>
					Añadir Serie
				</Button>
			</Box>

			<Box display='flex' gap={2} mb={2}>
				<TextField
					variant='outlined'
					placeholder='Buscar serie o descripción...'
					value={searchTerm}
					onChange={(e) => setSearchTerm(e.target.value)}
					InputProps={{
						startAdornment: <SearchIcon style={{ marginRight: 8 }} />,
					}}
					style={{ flex: 1 }}
				/>
				<FormControl variant='outlined' style={{ minWidth: 200 }}>
					<InputLabel>Equipo</InputLabel>
					<Select
						value={selectedTeam}
						onChange={(e) => setSelectedTeam(e.target.value)}
						label='Equipo'>
						<MenuItem value='ALL'>Todos</MenuItem>
						<MenuItem value='PERFUMERIA'>PERFUMERIA</MenuItem>
						<MenuItem value='COMPLEMENTOS'>COMPLEMENTOS</MenuItem>
					</Select>
				</FormControl>
			</Box>

			<div style={{ height: 500, width: '100%' }}>
				<DataGrid
					rows={filteredSeries}
					columns={columns}
					pageSize={100}
					loading={loading}
					disableSelectionOnClick
				/>
			</div>

			<SeriesDialog
				open={openDialog}
				onClose={() => setOpenDialog(false)}
				series={currentSeries}
				onSave={handleSaveSeries}
				onDelete={handleDeleteSeries}
			/>
		</div>
	);
}
